import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.regexp.split.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import AlignMixin from "./align.js";
import RippleMixin from "./ripple.js";
import ListenersMixin from "./listeners.js";
import RouterLinkMixin from "./router-link.js";
import { getSizeMixin } from "./size.js";
export var btnPadding = {
  none: 0,
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32
};
var formTypes = ['button', 'submit', 'reset'];
var mediaTypeRe = /[^\s]\/[^\s]/;
export var btnDesignOptions = ['flat', 'outline', 'push', 'unelevated'];
export var getBtnDesign = function getBtnDesign(vm, defaultValue) {
  if (vm.flat === true) return 'flat';
  if (vm.outline === true) return 'outline';
  if (vm.push === true) return 'push';
  if (vm.unelevated === true) return 'unelevated';
  return defaultValue;
};
export default {
  mixins: [ListenersMixin, RippleMixin, RouterLinkMixin, AlignMixin, getSizeMixin({
    xs: 8,
    sm: 10,
    md: 14,
    lg: 20,
    xl: 24
  })],
  props: _objectSpread(_objectSpread({
    type: {
      type: String,
      default: 'button'
    },
    to: [Object, String],
    replace: Boolean,
    append: Boolean,
    label: [Number, String],
    icon: String,
    iconRight: String
  }, btnDesignOptions.reduce(function (acc, val) {
    return (acc[val] = Boolean) && acc;
  }, {})), {}, {
    square: Boolean,
    round: Boolean,
    rounded: Boolean,
    glossy: Boolean,
    size: String,
    fab: Boolean,
    fabMini: Boolean,
    padding: String,
    color: String,
    textColor: String,
    noCaps: Boolean,
    noWrap: Boolean,
    dense: Boolean,
    tabindex: [Number, String],
    align: {
      default: 'center'
    },
    stack: Boolean,
    stretch: Boolean,
    loading: {
      type: Boolean,
      default: null
    },
    disable: Boolean
  }),
  computed: {
    style: function style() {
      if (this.fab === false && this.fabMini === false) {
        return this.sizeStyle;
      }
    },
    isRounded: function isRounded() {
      return this.rounded === true || this.fab === true || this.fabMini === true;
    },
    isActionable: function isActionable() {
      return this.disable !== true && this.loading !== true;
    },
    computedTabIndex: function computedTabIndex() {
      return this.isActionable === true ? this.tabindex || 0 : -1;
    },
    design: function design() {
      return getBtnDesign(this, 'standard');
    },
    attrs: function attrs() {
      var acc = {
        tabindex: this.computedTabIndex
      };
      if (this.hasLink === true) {
        Object.assign(acc, this.linkAttrs);
      } else if (formTypes.includes(this.type) === true) {
        acc.type = this.type;
      }
      if (this.linkTag === 'a') {
        if (this.disable === true) {
          acc['aria-disabled'] = 'true';
        } else if (acc.href === void 0) {
          acc.role = 'button';
        }
        if (this.hasRouterLink !== true && mediaTypeRe.test(this.type) === true) {
          acc.type = this.type;
        }
      } else if (this.disable === true) {
        acc.disabled = '';
        acc['aria-disabled'] = 'true';
      }
      if (this.loading === true && this.percentage !== void 0) {
        acc.role = 'progressbar';
        acc['aria-valuemin'] = 0;
        acc['aria-valuemax'] = 100;
        acc['aria-valuenow'] = this.percentage;
      }
      return acc;
    },
    classes: function classes() {
      var colors;
      if (this.color !== void 0) {
        if (this.flat === true || this.outline === true) {
          colors = "text-".concat(this.textColor || this.color);
        } else {
          colors = "bg-".concat(this.color, " text-").concat(this.textColor || 'white');
        }
      } else if (this.textColor) {
        colors = "text-".concat(this.textColor);
      }
      var shape = this.round === true ? 'round' : "rectangle".concat(this.isRounded === true ? ' q-btn--rounded' : this.square === true ? ' q-btn--square' : '');
      return "q-btn--".concat(this.design, " q-btn--").concat(shape) + (colors !== void 0 ? ' ' + colors : '') + (this.isActionable === true ? ' q-btn--actionable q-focusable q-hoverable' : this.disable === true ? ' disabled' : '') + (this.fab === true ? ' q-btn--fab' : this.fabMini === true ? ' q-btn--fab-mini' : '') + (this.noCaps === true ? ' q-btn--no-uppercase' : '') + (this.noWrap === true ? '' : ' q-btn--wrap') + (
      // this is for IE11
      this.dense === true ? ' q-btn--dense' : '') + (this.stretch === true ? ' no-border-radius self-stretch' : '') + (this.glossy === true ? ' glossy' : '');
    },
    innerClasses: function innerClasses() {
      return this.alignClass + (this.stack === true ? ' column' : ' row') + (this.noWrap === true ? ' no-wrap text-no-wrap' : '') + (this.loading === true ? ' q-btn__content--hidden' : '');
    },
    wrapperStyle: function wrapperStyle() {
      if (this.padding !== void 0) {
        return {
          padding: this.padding.split(/\s+/).map(function (v) {
            return v in btnPadding ? btnPadding[v] + 'px' : v;
          }).join(' '),
          minWidth: '0',
          minHeight: '0'
        };
      }
    }
  }
};